var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('download-excel',{staticClass:"btn btn-sm btn-info",attrs:{"data":_vm.dataItems,"fields":_vm.fieldsItems,"worksheet":"Folha1","name":"excel.xls"}},[_vm._v(" Exportar para excel ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }